export const teaching = [
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Données à large échelle",
    description: "Traitement de donnees a large echelle: architectures distribuees, passage a l'echelle et optimisation des traitements.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Intro DevOps",
    description: "Introduction aux pratiques DevOps: integration continue, deploiement continu, observabilite et automatisation.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DAMS 4",
    course: "Introduction à Kubernetes",
    description: "Orchestration de conteneurs avec Kubernetes: objets, deploiements, services et gestion des ressources.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DO4",
    course: "GitOps",
    description: "Gestion declarative des deploiements par depot Git: reconciliation continue, versionnement et tracabilite.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DO4",
    course: "Container & Orchestration",
    description: "Conteneurisation applicative et orchestration de services avec deploiements reproductibles.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "DO4",
    course: "Sys Admin",
    description: "Administration systeme: gestion des services, reseau, securisation et automatisation de l'exploitation.",
    link: ""
  },
  {
    period: "2026-2027",
    institution: "Polytech Montpellier",
    level: "PEIP 1",
    course: "Introduction à l'IA pour le web",
    description: "HA8103I - PEIP. Introduction a l'intelligence artificielle appliquee aux applications web.",
    link: ""
  },
  {
    period: "2025-2026",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Science des données",
    description: "Fondamentaux de la data science: preparation de donnees, modelisation statistique et evaluation.",
    link: ""
  },
  {
    period: "2025-2026",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "DevOps",
    description: "Pratiques DevOps: integration continue, deploiement continu, observabilite et automatisation.",
    link: ""
  },
  {
    period: "2025-2026",
    institution: "Polytech Montpellier",
    level: "DO3",
    course: "Conteneurs et Orchestration",
    description: "Conteneurisation applicative et orchestration de services avec deploiements reproductibles.",
    link: ""
  },
  {
    period: "2025-2026",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Données et IA",
    description: "Conception de pipelines de donnees et introduction aux methodes d'intelligence artificielle.",
    link: ""
  },
  {
    period: "2024-2025",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Données et IA",
    description: "Conception de pipelines de donnees et introduction aux methodes d'intelligence artificielle.",
    link: ""
  },
  {
    period: "2024-2025",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "DevOps",
    description: "Pratiques DevOps: integration continue, deploiement continu, observabilite et automatisation.",
    link: ""
  },
  {
    period: "2024-2025",
    institution: "Polytech Montpellier",
    level: "DAMS 4",
    course: "Tests, qualité et CI/CD",
    description: "Strategie de tests, qualite logicielle, integration continue et mise en place de pipelines CI/CD.",
    link: ""
  },
  {
    period: "2023-2024",
    institution: "Polytech Montpellier",
    level: "DAMS 4",
    course: "Données et IA",
    description: "Conception de pipelines de donnees et introduction aux methodes d'intelligence artificielle.",
    link: ""
  },
  {
    period: "2023-2024",
    institution: "Polytech Montpellier",
    level: "DAMS 5",
    course: "Urbanisation des SI",
    description: "Architecture d'entreprise, cartographie du SI et alignement des applications avec les besoins metier.",
    link: ""
  },
  {
    period: "2023-2024",
    institution: "Polytech Montpellier",
    level: "DAMS 4",
    course: "Tests et qualité",
    description: "Principes de verification logicielle, plans de tests et indicateurs de qualite.",
    link: ""
  },
  {
    period: "2023-2024",
    institution: "Polytech Montpellier",
    level: "DAMS 4",
    course: "Compilation",
    description: "Notions de compilation: analyse lexicale/syntaxique et generation de code simple.",
    link: ""
  },
  {
    period: "2021-2022",
    institution: "IUT Montpellier",
    level: "L1",
    course: "Technologie de l'Information et de la Communication 2",
    description: "Approfondissement des outils et usages numeriques dans un contexte universitaire et professionnel.",
    link: ""
  },
  {
    period: "2021-2022",
    institution: "IUT Montpellier",
    level: "L1",
    course: "Technologie de l'Information et de la Communication 1",
    description: "Introduction aux outils numeriques, communication digitale et bonnes pratiques informatiques.",
    link: ""
  },
  {
    period: "2021-2022",
    institution: "IUT Montpellier",
    level: "L2",
    course: "Technologie de l'Information et de la Communication 3",
    description: "Mise en pratique avancee des TIC avec methodes collaboratives et production de contenus.",
    link: ""
  },
  {
    period: "2020-2021",
    institution: "IUT Montpellier",
    level: "L1",
    course: "Technologie de l'Information et de la Communication 2",
    description: "Approfondissement des outils et usages numeriques dans un contexte universitaire et professionnel.",
    link: ""
  },
  {
    period: "2020-2021",
    institution: "IUT Montpellier",
    level: "L1",
    course: "Technologie de l'Information et de la Communication 1",
    description: "Introduction aux outils numeriques, communication digitale et bonnes pratiques informatiques.",
    link: ""
  },
  {
    period: "2020-2021",
    institution: "IUT Montpellier",
    level: "L2",
    course: "Technologie de l'Information et de la Communication 3",
    description: "Mise en pratique avancee des TIC avec methodes collaboratives et production de contenus.",
    link: ""
  },
  {
    period: "2014",
    institution: "Université Montpellier 2",
    level: "M2",
    course: "Moteur 3D",
    description: "Conception et programmation de moteurs 3D: scene, rendu, interactions et performances.",
    link: ""
  },
  {
    period: "2014",
    institution: "École Mines Ales",
    level: "M2",
    course: "Moteur 3D",
    description: "Conception et programmation de moteurs 3D: scene, rendu, interactions et performances.",
    link: ""
  },
  {
    period: "2012",
    institution: "Polytech UPMC",
    level: "M2",
    course: "Calcul parallèle",
    description: "Programmation parallele sur architectures multi-coeurs et acceleration des traitements.",
    link: ""
  },
  {
    period: "2011-2012",
    institution: "IUT Béziers",
    level: "L2",
    course: "Moteur 3D",
    description: "Initiation a la creation de scenes 3D et aux principes de rendu en temps reel.",
    link: ""
  },
  {
    period: "2010-2011",
    institution: "IUT Béziers",
    level: "L1-L2",
    course: "Représentation de l'information",
    description: "Methodes de modelisation et visualisation de l'information pour faciliter l'analyse.",
    link: ""
  },
  {
    period: "2010",
    institution: "IUT Béziers",
    level: "L1-L2",
    course: "Java",
    description: "Bases de la programmation objet en Java, structures de donnees et bonnes pratiques de code.",
    link: ""
  },
  {
    period: "2010",
    institution: "IUT Béziers",
    level: "L1-L2",
    course: "Modélisation 3D",
    description: "Principes de modelisation 3D et construction d'objets numeriques pour applications interactives.",
    link: ""
  }
];
